import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { returnSubmit } from "../../../enums/queryFunction/Submit";
import { SnackbarContext } from "../../../contexts/Snackbar";
import { HttpStatusCode } from "axios";
import logger from "../../../utils/logger";

export default function usePutAppointments(url, key, oldAppointment) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();

  const queryKey = key;

  const submitCallback = async (obj) => {
    setLoading(true);
    try {
      const response = await mutateAsync(obj);
      if (response?.status === HttpStatusCode.Ok) {
        setLoading(false);
        return true; 
      }
    } catch (error) {
      logger.error("Mutation failed:", error);
    }
    setLoading(false);
    return false;  
  };
  

  function updateKey(key, newData) {
    const updatedEntity = newData;
    queryClient.setQueryData([key], (oldData) => {
      if (!oldData) return oldData; // If no old data, return as is
      if (Array.isArray(oldData)) {
        return oldData.map((entity) =>
          Number(entity.id) === Number(updatedEntity.id)
            ? updatedEntity
            : entity
        );
      } else {
        return updatedEntity;
      }
    });
  }

  const { mutateAsync } = useMutation({
    mutationFn: (data) => returnSubmit(url, data),
    onSuccess: (response) => {
      if (response?.data) {
        const updatedData = {
          usersPets: oldAppointment?.usersPets ?? [],
          appointment: response?.data,
        };
        if (Array.isArray(queryKey)) {
          queryKey.forEach((key) => updateKey(key, updatedData));
        } else {
          updateKey(queryKey, updatedData);
        }
      } else {
        // Fallback
        queryClient.invalidateQueries([queryKey]);
      }

      handleSnackbar("successMessage", "success");
      setLoading(false);
    },
    onError: (error) => {
      handleSnackbar("errorMessage", "error");
      setLoading(false);
    },
  });

  return {
    submitCallback,
    loading,
  };
}
